import React from 'react'
import Menu from '@material-ui/icons/Menu'

export default function MenuIcon() {

    return (
        <Menu />
    )
}